/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for useSpecType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="useSpecType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="database"/&gt; &lt;enumeration value="file"/&gt; &lt;enumeration value="module"/&gt; &lt;enumeration value="dataset"/&gt; &lt;enumeration value="package"/&gt; &lt;enumeration value="wa_data_asset"/&gt; &lt;enumeration value="lwOLAP"/&gt; &lt;enumeration value="url"/&gt; &lt;enumeration value="report"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class UseSpecType extends Enum{

	enumValue = null;

	static  DATABASE = UseSpecType.newLiteral("database");

	static  FILE = UseSpecType.newLiteral("file");

	static  MODULE = UseSpecType.newLiteral("module");

	static  DATASET = UseSpecType.newLiteral("dataset");

	static  PACKAGE = UseSpecType.newLiteral("package");

	static  WA_DATA_ASSET = UseSpecType.newLiteral("wa_data_asset");

	static  LW_OLAP = UseSpecType.newLiteral("lwOLAP");

	static  URL = UseSpecType.newLiteral("url");

	static  REPORT = UseSpecType.newLiteral("report");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < UseSpecType.values().length); ++i) {
			if (UseSpecType.values()[i].enumValue == v) {
				return UseSpecType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("UseSpecType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/UseSpecType.js